import { SearchParams } from '@/types/common'
import { CreateSite, UpdateSite } from '@/types/site'
import { queryStringify } from '@/ultils'
import axiosClient from '../axiosClient'

const siteApi = {
  getAll(searchParams: SearchParams = {}) {
    const url = '/api/site'
    return axiosClient.get(url + queryStringify(searchParams))
  },

  getById(interfaceId?: string, searchParams: SearchParams = {}) {
    const url = `/api/site/${interfaceId}`
    return axiosClient.get(url + queryStringify(searchParams))
  },

  getBySiteId(interfaceId?: string, id?: string) {
    const url = `/api/site/${interfaceId}/${id}`
    return axiosClient.get(url)
  },

  create(payload: CreateSite) {
    const url = '/api/site'
    return axiosClient.post(url, payload)
  },
  delete(interfaceId: string, id: string) {
    const url = `/api/site/?interfaceId=${interfaceId}&id=${id}`
    return axiosClient.delete(url)
  },
  update(payload: UpdateSite) {
    const url = '/api/site'
    return axiosClient.put(url, payload)
  },
}

export default siteApi
